<h1>{{ 'account.profile.heading' | translate }}</h1>

<!-- Email -->
<div class="row section">
  <div class="col-10 col-lg-8">
    <h2 class="h3">{{ 'account.profile.email.heading' | translate }}</h2>
    <div class="row">
      <div class="col-md-12">
        <dl class="row dl-horizontal dl-separator">
          <dt class="col-md-4">{{ 'account.profile.email.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="email-field">{{ user.email }}</dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="col-2 col-lg-4 mt-3">
    <a
      *ishIdentityProviderCapability="'editEmail'"
      routerLink="/account/profile/email"
      class="btn-tool"
      [title]="'account.profile.update.link' | translate : { '0': 'account.profile.email.heading' | translate }"
      data-testing-id="edit-email"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
  </div>
</div>

<!-- Password -->
<div class="row section" *ishIdentityProviderCapability="'editPassword'">
  <div class="col-10 col-lg-8">
    <h2 class="h3">{{ 'account.profile.password.heading' | translate }}</h2>
    <div class="row">
      <div class="col-md-12">
        <dl class="row dl-horizontal dl-separator">
          <dt class="col-md-4">{{ 'account.profile.password.label' | translate }}</dt>
          <dd class="col-md-8">******</dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="col-2 col-lg-4 mt-3">
    <a
      routerLink="/account/profile/password"
      class="btn-tool"
      [title]="'account.profile.update.link' | translate : { '0': 'account.profile.password.heading' | translate }"
      data-testing-id="edit-password"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
  </div>
</div>
<!--Company Profile -->
<!--This is Commented for 6.0.0 version starts-->
<!-- <div *ngIf="customer.isBusinessCustomer" class="row section" data-testing-id="company-info">
  <div class="col-10 col-lg-8">
    <h3>{{ 'account.company_profile.detail.heading' | translate }}</h3>
    <div class="row">
      <div class="col-md-12">
        <dl class="row dl-horizontal dl-separator">
          <dt class="col-md-4">{{ 'account.company_profile.name.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="company-field">
            {{ customer.companyName }}<br />{{ customer.companyName2 }}
          </dd>
          <ng-container *ngIf="customer.industry">
            <dt class="col-md-4">{{ 'account.company_profile.industry.label' | translate }}</dt>
            <dd class="col-md-8">{{ customer.industry }}</dd>
          </ng-container>
          <dt class="col-md-4">{{ 'account.company_profile.taxation_id.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="taxation-id-field">{{ customer.taxationID }}</dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="col-2 col-lg-4 mt-3">
    <a
      *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'"
      routerLink="/account/profile/company"
      class="btn-tool"
      title="{{ 'account.profile.update.link' | translate }}"
      data-testing-id="edit-company"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
    </a>
  </div>
</div> -->

<!-- Profile -->
<div class="row section">
  <div class="col-10 col-lg-8">
    <h3>{{ 'account.profile.detail.heading' | translate }}</h3>
    <div class="row">
      <div class="col-md-12">
        <dl class="row dl-horizontal dl-separator">
          <dt class="col-md-4">{{ 'account.profile.name.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="name-field">
            {{ user.title ? user.title + ' ' : '' }}{{ user.firstName }} {{ user.lastName }}
          </dd>
          <!-- Phone -->
          <dt class="col-md-4">{{ 'account.profile.phone.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="phone-field">{{ user.phoneHome }}</dd>

          <!-- Birthday
          <dt class="col-md-4">{{ 'account.profile.birthday.label' | translate }}</dt>
          <dd class="col-md-8" data-testing-id="birthday-field">
            {{ user.birthday ? (user.birthday | ishDate) : ('account.profile.birthday.not_available' | translate) }}
          </dd>
          -->
        </dl>
      </div>
    </div>
  </div>
  <div class="col-2 col-lg-4 mt-3">
    <a
      *ishIdentityProviderCapability="'editProfile'"
      routerLink="/account/profile/user"
      class="btn-tool"
      [title]="'account.profile.update.link' | translate : { '0': 'account.profile.detail.heading' | translate }"
      data-testing-id="edit-user"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
  </div>
</div>

<!-- Note -->
<p class="form-text">
  {{ 'account.overview.note.heading' | translate }}:
  <span
    [ishServerHtml]="'account.overview.note.text' | translate : { '0': 'page://page.privacyPolicy.pagelet2-Page' }"
  ></span>
</p>
